import { Card, Grid } from '@design-systems/canvas-ui'
import { Icon, AiGenSimpleFillIcon } from '@design-systems/react-icons'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import type { RecommendedNextMoveProps } from './types'
import { NoData } from '../no-data/no-data'

export const RecommendedNextMove = ({ actions }: RecommendedNextMoveProps) => {
    const { t } = useEssentials()
    const { details } = TRANSLATION_KEYS.insights

    if (actions.length === 0) return null

    return (
        <Grid.Container
            direction="column"
            className="insight-details__recommended"
            aria-labelledby="insight-details-recommended-heading"
        >
            <Grid.Item>
                <h2
                    id="insight-details-recommended-heading"
                    className="hc8-clr-base hc8-fs-250"
                >
                    <strong>{t(details.recommendedNextMove)}</strong>
                </h2>
            </Grid.Item>
            {actions.length === 0 ? (
                <NoData />
            ) : (
                actions.map((action) => (
                    <Grid.Item key={action}>
                        <Card className="hc8-clr-disabled hc8-fs-050 hc8-pa-2x">
                            <Grid.Container
                                direction="row"
                                noWrap
                                spacing="dense"
                                align="flex-start"
                            >
                                <Grid.Item>
                                    <Icon
                                        svg={AiGenSimpleFillIcon}
                                        aria-hidden={true}
                                        size="md"
                                    />
                                </Grid.Item>
                                <Grid.Item>{action}</Grid.Item>
                            </Grid.Container>
                        </Card>
                    </Grid.Item>
                ))
            )}
        </Grid.Container>
    )
}
